import {onDomChanges} from "../../components/dynamic/observer";
import axios from "axios";

onDomChanges(() => {
  const actionLinks = document.querySelectorAll('[data-action-link]');
  actionLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const text = link.innerHTML;
      link.innerHTML = 'Обработка...';
      event.preventDefault();
      if (!confirm(link.dataset.actionLink)) {
        return;
      }
      axios.get(link.href)
        .then((response) => {
          if (response.data.message) {
            alert(response.data.message);
          }
          if (response.data.refresh) {
            link.innerHTML = 'Перезагрузка...';
            location.reload();
          } else {
            link.innerHTML = text;
          }
        })
        .catch((error) => {
          alert('Произошла ошибка');
          console.log(error);
          link.innerHTML = text;
        })
    });
  });
});